import React, { useState, useEffect } from "react"
import TagSelect from "./tagSelect"

interface Props {
  selectedTags: string[]
  allTags: string[]
  onChangeTags: (tags: string[]) => void
}

const Form = ({ selectedTags, allTags, onChangeTags }: Props) => {
  const onChangeTag1 = (tag: string) =>
    onChangeTags([tag, selectedTags[1], selectedTags[2]])
  const onChangeTag2 = (tag: string) =>
    onChangeTags([selectedTags[0], tag, selectedTags[2]])
  const onChangeTag3 = (tag: string) =>
    onChangeTags([selectedTags[0], selectedTags[1], tag])
  const randomizeTags = () => {
    const randomTag = () => allTags[Math.floor(Math.random() * allTags.length)]
    onChangeTags([randomTag(), randomTag(), randomTag()])
  }

  return (
    <div
      className="w-full flex-grow flex items-center w-auto block mt-2 bg-white z-20 mb-4"
      id="nav-content"
    >
      <ul className="list-reset flex items-center ml-4">
        <li className="mr-4">
          <button
            onClick={randomizeTags}
            className="rounded p-3 bg-green-400"
            aria-label="randomize"
          >
            <i
              className="fa fa-dice fa-lg fa-fw fa-inverse"
              aria-hidden={true}
            ></i>
          </button>
        </li>
        <li className="mr-4">
          <TagSelect
            options={allTags}
            value={selectedTags[0]}
            onChange={onChangeTag1}
          />
        </li>
        <li className="mr-4">
          <TagSelect
            options={allTags}
            value={selectedTags[1]}
            onChange={onChangeTag2}
          />
        </li>
        <li className="mr-4">
          <TagSelect
            options={allTags}
            value={selectedTags[2]}
            onChange={onChangeTag3}
          />
        </li>
      </ul>
    </div>
  )
}

export default Form
